const paths = {
  //Single paths
  "path.progress": "Progreso",
  "path.activity": "Actividad",
  "path.leaderboard": "Clasificación",
  "path.latest": "Feed",
  "path.challenges": "Desafíos",
  "path.team": "Equipo",
  "path.set": "Set Results",
  "path.settings": "Configuración",
  "path.session": "Resultados de la sesión",
  "path.scenario": "Resultados del escenario",

  "path.account": "Información de la cuenta",
  "path.privacy": "Privacidad y Compartir",
  "path.security": "Seguridad",
  "path.billing": "Facturación",
  "path.members": "Gestión de equipos",
  "path.help": "Ayuda y soporte",
  "path.about": "Acerca de",
  "path.password": "Configuración de contraseña",
  "path.pin": "Configuración de PIN",
  "path.admin": "Super Admin",
  "path.users": "Gestión de usuarios",
  "path.teams": "Gestión de equipos",
  "path.clubs": "Gestión de clubes",
  "path.training": "Configuración de entrenamiento",
  "path.bybcat": "BYBCAT",
  "path.bybcat.users": "Usuarios",
  "path.configs": "Configuraciones de pruebas",
  "path.results": "Resultados",
};

export default paths;
